/** Per-page options for the pinned pagination bar (default 10). */
export const PER_PAGE_OPTIONS = [10, 15, 25, 50];
export const DEFAULT_PER_PAGE = 10;

/** Total page count for a result set (never below 1, so the bar always renders). */
export function totalPages(count: number, pageSize: number): number {
  return Math.max(1, Math.ceil(count / Math.max(1, pageSize)));
}

/**
 * Result-count summary, e.g. "1–10 of 39" (or "0 of 0" when empty). `page` is
 * 1-based.
 */
export function countSummary(page: number, pageSize: number, count: number): string {
  if (count <= 0) return '0 of 0';
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, count);
  return `${start}–${end} of ${count}`;
}

/**
 * The window of page numbers to render around the current page. Shows every page
 * when there are few; otherwise a clamped window of `maxButtons` around `page`.
 */
export function pageWindow(page: number, pages: number, maxButtons = 5): number[] {
  if (pages <= maxButtons) return Array.from({ length: pages }, (_, i) => i + 1);
  const half = Math.floor(maxButtons / 2);
  let start = Math.max(1, page - half);
  const end = Math.min(pages, start + maxButtons - 1);
  start = Math.max(1, end - maxButtons + 1);
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
}

/** DRF LimitOffsetPagination params for a 1-based page + page size. */
export function limitOffset(page: number, pageSize: number): { limit: number; offset: number } {
  return { limit: pageSize, offset: (page - 1) * pageSize };
}
